<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">TRAVEL EXPENSE</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md12>
            <v-select
              class="mx-2"
              v-model="events"
              dense
              outlined
              label="Events"
              :items="events_items"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md12>
            <v-select
              class="mx-2"
              v-model="particulars"
              dense
              outlined
              label="Particulars"
              :items="particulars_items"
              item-value="particulars"
              :rules="rules.combobox_rule"
              @change="selected_particulars"
            ></v-select>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-if="can_select_description"
              class="mx-2"
              v-model="description"
              dense
              label="Description"
              outlined
              readonly
              @click="click_description"
            ></v-text-field>
            <v-text-field
              v-else
              class="mx-2"
              v-model="description"
              dense
              label="Description"
              outlined
              :rules="rules.default_max_100_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"
            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{alert_message}}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-dialog v-model="is_usage_click" persistent max-width="50%">
      <Accomodations
        v-on:data="on_save_usage"
        :key="this.key"
      ></Accomodations>
      <v-btn color="error" @click="is_usage_click = false"> Close</v-btn>
    </v-dialog>
    <v-dialog v-model="is_usage_click2" persistent max-width="50%">
      <Fare
        v-on:data="on_save_usage"
        :key="this.key"
      ></Fare>
      <v-btn color="error" @click="is_usage_click2 = false"> Close</v-btn>
    </v-dialog>
    <v-dialog v-model="is_usage_click3" persistent max-width="50%">
      <Meals
        v-on:data="on_save_usage"
        :key="this.key"
      ></Meals>
      <v-btn color="error" @click="is_usage_click3 = false"> Close</v-btn>
    </v-dialog>
  </div>
</template>
<script>

  import {mdiAlertOutline} from "@mdi/js";
  import {mapActions, mapGetters} from "vuex";
  import Accomodations
    from "@/views/file_interface/create/request/components/components_tranvel_expense/Accomodations";
  import Fare
    from "@/views/file_interface/create/request/components/components_tranvel_expense/Fare";
  import Meals
    from "@/views/file_interface/create/request/components/components_tranvel_expense/Meals";

  const initialState = () => {
    return {
      key: 0,
      can_select_description: false,
      is_usage_click: false,
      is_usage_click2: false,
      is_usage_click3: false,
      saving_request: false,
      alert: false,
      alert_message: '',
      events: '',
      particulars: '',
      particulars_items: ['Accommodation', 'Gas Expense', 'Meal Expense', 'Fare Expense', 'Others'],
      events_items: ['Training/Seminar', 'Employee Orientation', 'Branch Audit', 'Regional Meeting', 'Annual Convention', 'BOD Meeting', 'Employee Meeting', 'Tour Incentives', 'Transport Commodity', 'Branch Operation/Expansion'],
      description: '',
    }
  }
  export default {
    components: {
      Accomodations,
      Fare,
      Meals,
    },
    props: {
      branch_id: Number,
      particulars_id: Number,
      particulars_data_id: Number,
    },
    setup() {
      return {
        icons: {
          mdiAlertOutline,
        },
      }
    },
    data() {
      return initialState();
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
    },
    methods: {
      ...mapActions('request_data', ['check_revolving_fund_availability']),
      selected_year() {
        var index = this.year_items.map(function (x) {
          return x.year;
        }).indexOf(this.year)
        if (index != -1) {
          this.month_of_items = this.year_items[index].month_of
        }
      },
      selected_particulars(value) {
        this.can_select_description = false
        switch (value) {
          case 'Accommodation':
          case 'Fare Expense':
          case 'Meal Expense':
            this.can_select_description = true
            this.description = 'Please Click Me.!'
            break
        }
      },
      click_description() {
        this.key++
        switch (this.particulars) {
          case 'Accommodation':
            this.is_usage_click = true
            break
          case 'Fare Expense':
            this.is_usage_click2 = true
            break
          case 'Meal Expense':
            this.is_usage_click3 = true
            break
        }
      },
      on_save_usage(value) {
        this.is_usage_click = false
        this.is_usage_click2 = false
        this.is_usage_click3 = false
        this.description = value
      },
      done_request() {
        this.saving_request = true
        this.alert = false
        if (this.$refs.form.validate()) {
          this.$emit('data', this.particulars + ' # Desc.-' + this.description)
          this.saving_request = false
        } else {
          this.alert = true
          this.alert_message = 'Please Fill up the field/s'
          this.saving_request = false
        }
      },
    }
  }
</script>
